import React from "react";
type SunMarkProps = {
  className?: string;
};

/** Retro setting-sun motif: a solid disc whose lower half breaks into thinning stripes. Used on the More Work tile. */
export function SunMark({
  className = ""
}: SunMarkProps) {
  return <svg viewBox="0 0 40 40" className={className} aria-hidden="true" focusable="false" data-id="element-376" data-mp="1lgv0ez2e16bw">
      <defs data-id="element-377" data-mp="1ph5hb6rpxh5j">
        <clipPath id="sun-mark" data-id="element-378" data-mp="1pgx41droo9tt">
          <circle cx="20" cy="20" r="18" data-id="element-379" data-mp="2d6hpc3bb7j69" />
        </clipPath>
      </defs>
      <g clipPath="url(#sun-mark)" fill="currentColor" data-id="element-380" data-mp="2d8autfa6rxco">
        <rect x="0" y="0" width="40" height="20" className="fill-mustard" data-id="element-381" data-mp="2i49guw81l39x" />
        <rect x="0" y="22" width="40" height="4.5" data-id="element-382" data-mp="24efr8bopqez5" />
        <rect x="0" y="28.5" width="40" height="3.5" data-id="element-383" data-mp="24dnv8zr7ef8c" />
        <rect x="0" y="34" width="40" height="2.5" data-id="element-384" data-mp="28epw1l0rqzcf" />
        <rect x="0" y="38.25" width="40" height="1.75" data-id="element-385" data-mp="28deqbfnrjhio" />
      </g>
    </svg>;
}